import React from 'react';
import { TextField, Typography, Stack } from '@mui/material';
import type { ExecuteCheckpointDef } from '@/types/run-stage.types';

interface CheckpointDateProps {
  checkpoint: ExecuteCheckpointDef;
  value: unknown;
  onChange: (value: string) => void;
  error?: string;
  isReadOnly?: boolean;
}

export const CheckpointDate: React.FC<CheckpointDateProps> = ({
  checkpoint,
  value,
  onChange,
  error,
  isReadOnly,
}) => {
  const strValue = typeof value === 'string' ? value : '';
  // Format as datetime-local input
  const inputValue = strValue ? strValue.slice(0, 16) : '';

  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {checkpoint.checkpointName}
        {checkpoint.required && <Typography component="span" color="error"> *</Typography>}
      </Typography>
      <TextField
        size="small"
        type="datetime-local"
        value={inputValue}
        onChange={(e) => onChange(e.target.value ? new Date(e.target.value).toISOString() : '')}
        disabled={isReadOnly}
        error={Boolean(error)}
        helperText={error}
        fullWidth
      />
    </Stack>
  );
};
